// loadMixpanelLogMeta.js

/**
 * Loads mixpanel's `getLogMeta` on demand and runs it.
 *
 * Why this lives in its own file:
 * This `import(...)` only belongs to the main app, not the Service Worker.
 * But the SW imports `sentry.js`, and if this line were inside `sentry.js`,
 * webpack would pull extra stuff into the SW file and make it look "new" on
 * every deploy (causing needless SW reinstalls). Keeping the line here — a
 * file the SW never imports — avoids that.
 *
 * The main app wires it up at startup:
 *   setLogMetaLoader(loadMixpanelLogMeta)   // from ../index.js
 *
 * @returns {Promise<object>} The log metadata from `mixpanel.getLogMeta()`.
 * @example
 * import { loadMixpanelLogMeta } from '../resource/loadMixpanelLogMeta.js';
 * import { setLogMetaLoader } from '../resource/sentry.js';
 * setLogMetaLoader(loadMixpanelLogMeta);
 */
const loadMixpanelLogMeta = async () => {
  const { getLogMeta } = await import('../resource/mixpanel.js');
  return getLogMeta();
};

export { loadMixpanelLogMeta };
